import React from 'react';

const MilanoBanner = () => {
    return (
        <section className="relative w-full overflow-hidden bg-perfetto-lut">
            <img
                src="/img/milano-a-tavola.jpeg"
                alt="Milano a Tavola"
                className="block w-full h-auto"
            />
            <a
                href="https://perfettocucinaitaliana.ro/evenimente/milano-a-tavola/"
                target="_blank"
                rel="noopener noreferrer"
                className="block w-full px-4 py-4 text-sm tracking-[0.24em] text-center text-[#f0c267] uppercase transition border-y border-[#a76d24] shadow-inner font-perfetto bg-[#050403] hover:bg-[#120d08] hover:text-white"
            >
                Rezervari
            </a>
        </section>
    );
};

export default MilanoBanner;
